import { render, staticRenderFns } from "./iybr-new-project-collapsible.vue?vue&type=template&id=bf22fdac"
import script from "./iybr-new-project-collapsible.ts?vue&type=script&lang=ts&external"
export * from "./iybr-new-project-collapsible.ts?vue&type=script&lang=ts&external"
import style0 from "./iybr-new-project-collapsible.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf22fdac')) {
      api.createRecord('bf22fdac', component.options)
    } else {
      api.reload('bf22fdac', component.options)
    }
    module.hot.accept("./iybr-new-project-collapsible.vue?vue&type=template&id=bf22fdac", function () {
      api.rerender('bf22fdac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/iybr-new-project-collapsible/iybr-new-project-collapsible.vue"
export default component.exports